<template>
   <div>
      <el-dialog
    title="修改详情"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="50%" 
    v-if="role == 'company'"
  >
    <div class="product-add pb50">
      <el-form size="small" :model="form" ref="form" label-width="100px">



<el-form-item label="所属协会" prop="enterprise_id" :rules="[{ required: true, message: '请选择协会', trigger: 'change' }]">
  <el-select
    v-model="form.enterprise_id"
    placeholder="请选择协会"
    filterable
    clearable
    class="max-w460"
  >
    <el-option
      v-for="item in enterprise"
      :key="item.supply_id"
      :label="item.name"
      :value="item.supply_id"
    ></el-option>
  </el-select>
</el-form-item>

        <el-form-item label="政商企bannar：" prop="model.image">
          <div class="draggable-list">
            <draggable class="wrapper" v-model="form.bannar">
              <transition-group>
                <div v-for="(item, index) in form.bannar" :key="item.file_path">
                  <div class="item">
                    <img v-img-url="item.file_path" alt="file_path"/>
                    <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg(index,'bannar')">
                      <i class="el-icon-close"></i>
                    </a>
                  </div>
                </div>
              </transition-group>
            </draggable>
            <div class="item img-select" @click="openProductUpload('bannar')">
              <i class="el-icon-plus"></i>
            </div>
          </div>
        </el-form-item>

         <el-form-item label="政商企图片：" prop="model.image">
          <div class="draggable-list">
            <draggable class="wrapper" v-model="form.image">
              <transition-group>
                <div v-for="(item, index) in form.image" :key="item.file_path">
                  <div class="item">
                    <img v-img-url="item.file_path" alt="file_path"/>
                    <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg(index,'album')">
                      <i class="el-icon-close"></i>
                    </a>
                  </div>
                </div>
              </transition-group>
            </draggable>
            <div class="item img-select" @click="openProductUpload('album')">
              <i class="el-icon-plus"></i>
            </div>
          </div>
        </el-form-item>


        <el-form-item label="政商企视频：">
           <div class="draggable-list">
            <draggable class="wrapper" v-model="form.video">
              <transition-group>
                 <div v-for="(item, index) in form.video" :key="item.file_path">
                  <div class="item">
                    <video
              :src="item.file_path"
              controls
              class="video-preview"
            ></video>
              </div>
                    <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg(index,'video')">
                      <i class="el-icon-close"></i>
                    </a>
                  </div>


              </transition-group>
            </draggable>
            <div class="item img-select"   @click="openProductUpload('video')">
              <i class="el-icon-plus"></i>
            </div>
          </div>

        </el-form-item>

        <el-form-item label="视频封面" prop="model.image">
          <div class="draggable-list">
            <draggable class="wrapper" v-model="form.cover">
              <transition-group>
                <div v-for="(item, index) in form.cover" :key="item.file_path">
                  <div class="item">
                    <img v-img-url="item.file_path" alt="file_path"/>
                    <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg(index,'cover')">
                      <i class="el-icon-close"></i>
                    </a>
                  </div>
                </div>
              </transition-group>
            </draggable>
            <div class="item img-select" @click="openProductUpload('cover')">
              <i class="el-icon-plus"></i>
            </div>
          </div>
        </el-form-item>
         <el-form-item label="视频背景" prop="model.image">
          <div class="draggable-list">
            <draggable class="wrapper" v-model="form.bg">
              <transition-group>
                <div v-for="(item, index) in form.bg" :key="item.file_path">
                  <div class="item">
                    <img v-img-url="item.file_path" alt="file_path"/>
                    <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg(index,'bg')">
                      <i class="el-icon-close"></i>
                    </a>
                  </div>
                </div>
              </transition-group>
            </draggable>
            <div class="item img-select" @click="openProductUpload('bg')">
              <i class="el-icon-plus"></i>
            </div>
          </div>
        </el-form-item>
        <!-- 在视频模块后面添加这个 -->
<el-form-item label="公众号二维码">
  <div class="draggable-list">
    <draggable class="wrapper" v-model="form.qrcode">
      <transition-group>
        <div v-for="(item, index) in form.qrcode" :key="item.file_path">
          <div class="item">
            <img v-img-url="item.file_path" alt="公众号二维码"/>
            <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg(index,'qrcode')">
              <i class="el-icon-close"></i>
            </a>
          </div>
        </div>
      </transition-group>
    </draggable>
    <div class="item img-select" @click="openProductUpload('qrcode')">
      <i class="el-icon-plus"></i>
    </div>
  </div>
  <div class="el-upload__tip">建议尺寸：300x300像素，支持JPG、PNG格式</div>
</el-form-item>

                <!-- Qualifications -->

         <el-form-item label="企业资质" prop="model.image">
          <div class="draggable-list">
            <draggable class="wrapper" v-model="form.qualifications">
              <transition-group>
                <div v-for="(item, index) in form.qualifications" :key="item.file_path">
                  <div class="item">
                    <img v-img-url="item.file_path" alt="file_path"/>
                    <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg(index,'qualifications')">
                      <i class="el-icon-close"></i>
                    </a>
                  </div>
                </div>
              </transition-group>
            </draggable>
            <div class="item img-select" @click="openProductUpload('qualifications')">
              <i class="el-icon-plus"></i>
            </div>
          </div>
        </el-form-item>

         <!-- 企业荣誉模块（添加图片上传） -->
        <el-form-item label="企业荣誉">
          <div class="honors-list">
            <div v-for="(honor, index) in form.honora" :key="index" class="honor-item">
              <!-- 荣誉图片上传 -->
              <div class="honor-image-upload">
                <div class="draggable-list">
                  <draggable class="wrapper" v-model="honor.images">
                    <transition-group>
                      <div v-for="(img, imgIndex) in honor.images" :key="img.file_path">
                        <div class="item">
                          <img v-img-url="img.file_path" alt="荣誉图片"/>
                          <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteHonorImg(index, imgIndex)">
                            <i class="el-icon-close"></i>
                          </a>
                        </div>
                      </div>
                    </transition-group>
                  </draggable>
                  <div class="item img-select" @click="openHonorImageUpload(index)">
                    <i class="el-icon-plus"></i>
                  </div>
                </div>
                <div class="el-upload__tip">建议尺寸：300x300像素，支持JPG、PNG格式</div>
              </div>
              
              
              <!-- 删除荣誉项 -->
              <a href="javascript:void(0);" class="delete-btn honor-delete-btn" @click.stop="deleteHonora(index)">
                <i class="el-icon-close"></i>
              </a>
            </div>

            <!-- 添加荣誉项 -->
            <div class="add-honor" @click="addHonora">
              <i class="el-icon-plus"></i>
              <span>添加荣誉</span>
            </div>
          </div>
        </el-form-item>


        <el-form-item label="政商企介绍">
          <div class="edit_container">
            <Uediter v-model="form.intro" :text="ueditor.text" :config="ueditor.config" ref="ue"></Uediter>
          </div>
        </el-form-item>

        <!-- Contact Information -->
        <el-form-item label="地址">
          <el-input v-model="form.address" placeholder="请输入地址" class="max-w460"></el-input>
        </el-form-item>
        <el-form-item label="联系电话">
          <el-input v-model="form.phone" placeholder="请输入联系电话" class="max-w460"></el-input>
        </el-form-item>

        <el-form-item label="联系邮箱">
          <el-input v-model="form.email" placeholder="请输入联系邮箱" class="max-w460"></el-input>
        </el-form-item>

                     <el-form-item label="在线工厂密码">
          <el-input  type="password" v-model="form.camera_pass" placeholder="请输入在线工厂密码" class="max-w460"></el-input>
        </el-form-item>






        <!--提交-->
        <div class="common-button-wrapper">
          <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
          <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
        </div>
      </el-form>
      <Upload v-if="isProductUpload" :config="{ total: 9 }" :isupload="isProductUpload" @returnImgs="returnProductImgsFunc">上传图片</Upload>
    </div>
  </el-dialog>








  <el-dialog
    title="添加详情"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="50%" 
    v-if="role == 'government'"
  >
    <div class="product-add pb50">
      <el-form size="small" :model="form" ref="form" label-width="100px">



       

        <el-form-item label="政府bannar：" prop="model.image">
          <div class="draggable-list">
            <draggable class="wrapper" v-model="form.bannar">
              <transition-group>
                <div v-for="(item, index) in form.bannar" :key="item.file_path">
                  <div class="item">
                    <img v-img-url="item.file_path" alt="file_path"/>
                    <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg(index,'bannar')">
                      <i class="el-icon-close"></i>
                    </a>
                  </div>
                </div>
              </transition-group>
            </draggable>
            <div class="item img-select" @click="openProductUpload('bannar')">
              <i class="el-icon-plus"></i>
            </div>
          </div>
        </el-form-item>

         <el-form-item label="政府图片：" prop="model.image">
          <div class="draggable-list">
            <draggable class="wrapper" v-model="form.image">
              <transition-group>
                <div v-for="(item, index) in form.image" :key="item.file_path">
                  <div class="item">
                    <img v-img-url="item.file_path" alt="file_path"/>
                    <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg(index,'album')">
                      <i class="el-icon-close"></i>
                    </a>
                  </div>
                </div>
              </transition-group>
            </draggable>
            <div class="item img-select" @click="openProductUpload('album')">
              <i class="el-icon-plus"></i>
            </div>
          </div>
        </el-form-item>


        <el-form-item label="政府视频：">
           <div class="draggable-list">
            <draggable class="wrapper" v-model="form.video">
              <transition-group>
                 <div v-for="(item, index) in form.video" :key="item.file_path">
                  <div class="item">
                    <video
              :src="item.file_path"
              controls
              class="video-preview"
            ></video>
              </div>
                    <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg(index,'video')">
                      <i class="el-icon-close"></i>
                    </a>
                  </div>


              </transition-group>
            </draggable>
            <div class="item img-select"    @click="openProductUpload('video')">
              <i class="el-icon-plus"></i>
            </div>
          </div>

        </el-form-item>
        <el-form-item label="视频封面" prop="model.image">
          <div class="draggable-list">
            <draggable class="wrapper" v-model="form.cover">
              <transition-group>
                <div v-for="(item, index) in form.cover" :key="item.file_path">
                  <div class="item">
                    <img v-img-url="item.file_path" alt="file_path"/>
                    <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg(index,'cover')">
                      <i class="el-icon-close"></i>
                    </a>
                  </div>
                </div>
              </transition-group>
            </draggable>
            <div class="item img-select" @click="openProductUpload('cover')">
              <i class="el-icon-plus"></i>
            </div>
          </div>
        </el-form-item>
             <el-form-item label="视频背景" prop="model.image">
          <div class="draggable-list">
            <draggable class="wrapper" v-model="form.bg">
              <transition-group>
                <div v-for="(item, index) in form.bg" :key="item.file_path">
                  <div class="item">
                    <img v-img-url="item.file_path" alt="file_path"/>
                    <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg(index,'bg')">
                      <i class="el-icon-close"></i>
                    </a>
                  </div>
                </div>
              </transition-group>
            </draggable>
            <div class="item img-select" @click="openProductUpload('bg')">
              <i class="el-icon-plus"></i>
            </div>
          </div>
        </el-form-item>

                <!-- 在视频模块后面添加这个 -->
<el-form-item label="公众号二维码">
  <div class="draggable-list">
    <draggable class="wrapper" v-model="form.qrcode">
      <transition-group>
        <div v-for="(item, index) in form.qrcode" :key="item.file_path">
          <div class="item">
            <img v-img-url="item.file_path" alt="公众号二维码"/>
            <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg(index,'qrcode')">
              <i class="el-icon-close"></i>
            </a>
          </div>
        </div>
      </transition-group>
    </draggable>
    <div class="item img-select" @click="openProductUpload('qrcode')">
      <i class="el-icon-plus"></i>
    </div>
  </div>
  <div class="el-upload__tip">建议尺寸：300x300像素，支持JPG、PNG格式</div>
</el-form-item>

        
                        <!-- 政府荣誉 -->
                           <el-form-item  label="政府荣誉">
                            <div class="honors-list">
                                <div v-for="(honor, index) in form.honors" :key="index" class="honor-item">
                                    <el-input
                                        v-model="honor.text"
                                        placeholder="请输入荣誉内容"
                                        class="honor-input"
                                        type="textarea"
                                        :rows="2"
                                    ></el-input>
                                    <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteHonor(index)">
                                        <i class="el-icon-close"></i>
                                    </a>
                                </div>

                                <div class="add-honor" @click="addHonor">
                                    <i class="el-icon-plus"></i>
                                    <span>添加荣誉</span>
                                </div>
                            </div>
                        </el-form-item>

         

        <el-form-item label="政府介绍">
          <div class="edit_container">
            <Uediter  v-model="form.intro" :text="ueditor.text" :config="ueditor.config" ref="ue"></Uediter>
          </div>
        </el-form-item>

        <!-- Contact Information -->
        <el-form-item label="地址">
          <el-input v-model="form.address" placeholder="请输入地址" class="max-w460"></el-input>
        </el-form-item>

        <el-form-item label="联系电话">
          <el-input v-model="form.phone" placeholder="请输入联系电话" class="max-w460"></el-input>
        </el-form-item>

        <el-form-item label="联系邮箱">
          <el-input v-model="form.email" placeholder="请输入联系邮箱" class="max-w460"></el-input>
        </el-form-item>

  


        <el-form-item label="排序" prop="name">
          <el-input v-model="form.sort" placeholder="请输入排序" class="max-w460"></el-input>
        </el-form-item>

        <!--提交-->
        <div class="common-button-wrapper">
          <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
          <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
        </div>
      </el-form>
      <Upload v-if="isProductUpload" :config="{ total: 9 }" :isupload="isProductUpload" @returnImgs="returnProductImgsFunc">上传图片</Upload>
    </div>
  </el-dialog>





    <el-dialog
    title="编辑详情"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="50%" 
    v-if="role == 'shanghui'"
  >
    <div class="product-add pb50">
      <el-form size="small" :model="form" ref="form" label-width="100px">



              <el-form-item label="所属协会" prop="enterprise_id" :rules="[{ required: true, message: '请选择协会', trigger: 'change' }]">
          <el-select
            v-model="form.enterprise_id"
            placeholder="请选择协会"
            filterable
            clearable
            class="max-w460"
          >
            <el-option
              v-for="item in enterprise"
              :key="item.supply_id"
              :label="item.name"
              :value="item.supply_id"
            ></el-option>
          </el-select>
        </el-form-item>


        <el-form-item label="商会bannar：" prop="model.image">
          <div class="draggable-list">
            <draggable class="wrapper" v-model="form.bannar">
              <transition-group>
                <div v-for="(item, index) in form.bannar" :key="item.file_path">
                  <div class="item">
                    <img v-img-url="item.file_path" alt="file_path"/>
                    <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg(index,'bannar')">
                      <i class="el-icon-close"></i>
                    </a>
                  </div>
                </div>
              </transition-group>
            </draggable>
            <div class="item img-select" @click="openProductUpload('bannar')">
              <i class="el-icon-plus"></i>
            </div>
          </div>
        </el-form-item>

         <el-form-item label="商会图片：" prop="model.image">
          <div class="draggable-list">
            <draggable class="wrapper" v-model="form.image">
              <transition-group>
                <div v-for="(item, index) in form.image" :key="item.file_path">
                  <div class="item">
                    <img v-img-url="item.file_path" alt="file_path"/>
                    <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg(index,'album')">
                      <i class="el-icon-close"></i>
                    </a>
                  </div>
                </div>
              </transition-group>
            </draggable>
            <div class="item img-select" @click="openProductUpload('album')">
              <i class="el-icon-plus"></i>
            </div>
          </div>
        </el-form-item>


        <el-form-item label="商会视频：">
           <div class="draggable-list">
            <draggable class="wrapper" v-model="form.video">
              <transition-group>
                 <div v-for="(item, index) in form.video" :key="item.file_path">
                  <div class="item">
                    <video
              :src="item.file_path"
              controls
              class="video-preview"
            ></video>
              </div>
                    <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg(index,'video')">
                      <i class="el-icon-close"></i>
                    </a>
                  </div>


              </transition-group>
            </draggable>
            <div class="item img-select"    @click="openProductUpload('video')">
              <i class="el-icon-plus"></i>
            </div>
          </div>

        </el-form-item>
        <el-form-item label="视频封面" prop="model.image">
          <div class="draggable-list">
            <draggable class="wrapper" v-model="form.cover">
              <transition-group>
                <div v-for="(item, index) in form.cover" :key="item.file_path">
                  <div class="item">
                    <img v-img-url="item.file_path" alt="file_path"/>
                    <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg(index,'cover')">
                      <i class="el-icon-close"></i>
                    </a>
                  </div>
                </div>
              </transition-group>
            </draggable>
            <div class="item img-select" @click="openProductUpload('cover')">
              <i class="el-icon-plus"></i>
            </div>
          </div>
        </el-form-item>
             <el-form-item label="视频背景" prop="model.image">
          <div class="draggable-list">
            <draggable class="wrapper" v-model="form.bg">
              <transition-group>
                <div v-for="(item, index) in form.bg" :key="item.file_path">
                  <div class="item">
                    <img v-img-url="item.file_path" alt="file_path"/>
                    <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg(index,'bg')">
                      <i class="el-icon-close"></i>
                    </a>
                  </div>
                </div>
              </transition-group>
            </draggable>
            <div class="item img-select" @click="openProductUpload('bg')">
              <i class="el-icon-plus"></i>
            </div>
          </div>
        </el-form-item>

                <!-- 在视频模块后面添加这个 -->
<el-form-item label="公众号二维码">
  <div class="draggable-list">
    <draggable class="wrapper" v-model="form.qrcode">
      <transition-group>
        <div v-for="(item, index) in form.qrcode" :key="item.file_path">
          <div class="item">
            <img v-img-url="item.file_path" alt="公众号二维码"/>
            <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg(index,'qrcode')">
              <i class="el-icon-close"></i>
            </a>
          </div>
        </div>
      </transition-group>
    </draggable>
    <div class="item img-select" @click="openProductUpload('qrcode')">
      <i class="el-icon-plus"></i>
    </div>
  </div>
  <div class="el-upload__tip">建议尺寸：300x300像素，支持JPG、PNG格式</div>
</el-form-item>

                   <el-form-item label="企业资质" prop="model.image">
          <div class="draggable-list">
            <draggable class="wrapper" v-model="form.qualifications">
              <transition-group>
                <div v-for="(item, index) in form.qualifications" :key="item.file_path">
                  <div class="item">
                    <img v-img-url="item.file_path" alt="file_path"/>
                    <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg(index,'qualifications')">
                      <i class="el-icon-close"></i>
                    </a>
                  </div>
                </div>
              </transition-group>
            </draggable>
            <div class="item img-select" @click="openProductUpload('qualifications')">
              <i class="el-icon-plus"></i>
            </div>
          </div>
        </el-form-item>

        <el-form-item label="商会介绍">
          <div class="edit_container">
            <Uediter v-model="form.intro" :text="ueditor.text" :config="ueditor.config" ref="ue"></Uediter>
          </div>
        </el-form-item>

        <!-- Contact Information -->
        <el-form-item label="地址">
          <el-input v-model="form.address" placeholder="请输入地址" class="max-w460"></el-input>
        </el-form-item>
        <el-form-item label="联系电话">
          <el-input v-model="form.phone" placeholder="请输入联系电话" class="max-w460"></el-input>
        </el-form-item>

        <el-form-item label="联系邮箱">
          <el-input v-model="form.email" placeholder="请输入联系邮箱" class="max-w460"></el-input>
        </el-form-item>

  

                

        <el-form-item label="排序" prop="name">
          <el-input v-model="form.sort" placeholder="请输入排序" class="max-w460"></el-input>
        </el-form-item>

        <!--提交-->
        <div class="common-button-wrapper">
          <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
          <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
        </div>
      </el-form>
      <Upload v-if="isProductUpload" :config="{ total: 9 }" :isupload="isProductUpload" @returnImgs="returnProductImgsFunc">上传图片</Upload>
    </div>
  </el-dialog>
  </div>
  
</template>

<script>
import EnterpriseApi from '@/api/enterprise.js';
import Supply_detailApi from '@/api/supply_detail.js';
import FileApi from '@/api/file.js';
import Upload from '@/components/file/Upload';
import draggable from "vuedraggable";
import Uediter from '@/components/UE.vue';
import { isArray } from 'lodash';

export default {
  components: {
    Upload,
    draggable,
    Uediter
  },
  data() {
    return {
      isupload: false,
      isImg: false,
      ueditor: {
        text: '',
        config: {
          initialFrameWidth: 400,
          initialFrameHeight: 500
        }
      },
      form: {
        name: '',
         introduce: '',
        code: 'custom',
        image: [],
        cover:[],
         qrcode: [],
        bg:[],
         honors: [
          {text: ''}
          ],
           honora: [
          {
            text: '',
            images: []  // 每个荣誉项都有独立的图片数组
          }
        ],
          
        status:0,
        video: [],
        sort: 50,
        intro: "",
        bannar: [],
         phone: '',
          email: '',
          address: '',
        qualifications: []
      },
      loading: false,
  
      enterprise:[],
      dialogVisible: false,
      isProductUpload: false,
      code: "album"
    };
  },
  props: ["open_add", "supply_detail_id",'supply_id','role'],
  watch: {
    open_add(val) {
      this.dialogVisible = val;
      if (val) {
        this.getDetail();
      }
    }
  },
  methods: {
    beforeVideoUpload(file) {
      const isVideo = /\.(mp4|avi|mov|wmv|flv|mkv)$/i.test(file.name);
      const isLt50M = file.size / 1024 / 1024 < 50;

      if (!isVideo) {
        this.$message.error('请上传视频文件 (MP4/AVI/MOV/WMV/FLV/MKV)！');
        return false;
      }
      if (!isLt50M) {
        this.$message.error('视频大小不能超过50MB！');
        return false;
      }

      const invalidChars = /[<>:"\/\\|?*\x00-\x1F]/g;
      if (invalidChars.test(file.name)) {
        this.$message.error('文件名包含非法字符，请重命名后上传！');
        return false;
      }

      return true;
    },
          /* 获取协会列表 */
    getEnterpriseList() {
      EnterpriseApi.listx({}, true)
        .then(response => {
          this.enterprise = response.data.list;
        })
        .catch(error => {
          console.error('获取协会列表失败:', error);
        });
    },

    uploadVideo(param) {
      const loading = this.$loading({
        lock: true,
        text: '视频上传中,请等待',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });

      const formData = new FormData();
      formData.append('iFile', param.file);

      FileApi.uploadFile(formData)
        .then(response => {
          loading.close();
          this.form.video = response.data.file_path;
          this.$message.success('视频上传成功！');
        })
        .catch(error => {
          loading.close();
          console.error('上传失败:', error);
          this.$message.error('视频上传失败，请检查文件格式或网络！');
        });
    },

    removeVideo() {
      this.form.video = null;
    },
        addHonor() {
                    this.form.honors.push({
                        text: ''
                    });
                },
                    deleteHonor(index) {
                    this.form.honors.splice(index, 1);
                },

    dialogFormVisible(result) {
      this.$emit("close", {});
    },

    cancelFunc() {
      this.dialogFormVisible("error");
    },
        openHonorImageUpload(honorIndex) {
      this.isProductUpload = true;
      this.code = 'honor_image';
      this.currentHonorIndex = honorIndex; // 记录当前操作的荣誉项索引
    },

    getDetail() {
      let self = this;
      Supply_detailApi.detail({supply_detail_id: self.supply_detail_id}, true)
        .then(res => {
          self.form = {
            ...res.data,
            contact: res.data.contact || { phone: '', email: '', address: '' },
            qualifications: res.data.qualifications || [],
            bannar: res.data.bannar || [],
            image: res.data.image || [],
            qrcode: res.data.qrcode || [],
             cover: res.data.cover || [],
             bg: res.data.bg || [],
              honora: res.data.honora || [{ text: '', images: [] }],          
             honors:res.data.honors || [{text: ''}],            
          };

      // 确保 intro 内容正确设置
      self.form.intro = res.data.intro || '';
                self.ueditor.text = self.form.intro;
          self.isImg = true;
          self.loading = false;
 

          if(isArray(res.data.image)&&res.data.image[0].file_path){
            self.form.video = res.data.image;
          }else{
            const video = [{
              file_path:res.data.image
            }]
            self.form.video = video;
            console.log('video',self.form.video);

          }


          if (res.data.video) {
            self.form.video = res.data.video;
          }
        })
        .catch(error => {
          console.error(error);
        });
    },
    handleSelectChange(enterpriseId) {
      // 从选项列表中找到当前选中的完整对象
      const selectedItem = this.enterprise.find(item => item.enterprise_id === enterpriseId);
      if (selectedItem) {
        this.form.supply_id = selectedItem.supply_id;  // 赋值supply_id
        this.form.name = selectedItem.name;            // 赋值name
      } else {
        // 未找到对应项时清空
        this.form.supply_id = '';
        this.form.name = '';
      }
    },
    onSubmit() {
        const selectedEnterprise = this.enterprise.find(item => item.supply_id === this.form.enterprise_id);
  this.form.name = selectedEnterprise ? selectedEnterprise.name : '';
      console.log('提交数据:', this.form);
      let self = this;
      let form = self.form;

      form.supply_detail_id = self.supply_detail_id;
      form.intro = this.$refs.ue.getUEContent();
      form.supply_id = self.supply_id;
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          Supply_detailApi.edit(form, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: data.msg,
                type: 'success'
              });
              self.dialogFormVisible("error");
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },
     /* 添加荣誉项 */
    addHonora() {
      this.form.honora.push({
        text: '',
        images: []
      });
    },

    /* 删除荣誉项 */
    deleteHonora(index) {
      if (this.form.honora.length > 1) {
        this.form.honora.splice(index, 1);
      } else {
        this.$message.warning('至少保留一个荣誉项');
      }
    },

    /* 删除荣誉图片 */
    deleteHonorImg(honorIndex, imgIndex) {
      this.form.honora[honorIndex].images.splice(imgIndex, 1);
    },

    openProductUpload(code) {
      this.isProductUpload = true;
      this.code = code;
    },

    returnProductImgsFunc(e) {
      if (e != null && e.length > 0) {
        let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
        let prevent = false;

        // 检查图片格式
        e.forEach((element) => {
          let data_array = element.file_path.split(".");
          let ext = data_array[data_array.length - 1].toLowerCase();
          if (imgExpt.includes(ext)) {
            prevent = true;
          }
        });

        if (!prevent) {
          this.$message.error("图片类型有误,请选择正确的图片格式");
          this.isProductUpload = false;
          return false;
        }

        // 根据不同的上传类型处理图片
        switch (this.code) {
          case 'album':
            let albumImgs = this.form.image.concat(e);
            this.$set(this.form, "image", albumImgs);
            break;
          case 'qrcode':
            let qrcodeImgs = this.form.qrcode.concat(e);
            this.$set(this.form, "qrcode", qrcodeImgs);
            break;
          case 'bannar':
            let bannarImgs = this.form.bannar.concat(e);
            this.$set(this.form, "bannar", bannarImgs);
            break;
          case 'cover':
            let coverImgs = this.form.cover.concat(e);
            this.$set(this.form, "cover", coverImgs);
            break;
          case 'qualifications':
            let qualificationsImgs = this.form.qualifications.concat(e);
            this.$set(this.form, "qualifications", qualificationsImgs);
            break;
          case 'bg':
            let bgImgs = this.form.bg.concat(e);
            this.$set(this.form, "bg", bgImgs);
            break;
          case 'honor_image':
            // 将图片添加到当前操作的荣誉项中
            if (this.currentHonorIndex >= 0) {
              let honorImgs = this.form.honora[this.currentHonorIndex].images.concat(e);
              this.$set(this.form.honora[this.currentHonorIndex], "images", honorImgs);
            }
            break;
          default:
            // 视频上传逻辑
            let videoExpt = ["mp4","avi","mov","mkv","wmv","flv","webm"];
            let videoPrevent = false;
            e.forEach((element) => {
              let data_array = element.file_path.split(".");
              let ext = data_array[data_array.length - 1].toLowerCase();
              if (videoExpt.includes(ext)) {
                videoPrevent = true;
              }
            });
            if (!videoPrevent) {
              this.$message.error("视频类型有误,请选择正确的视频格式");
              this.isProductUpload = false;
              return false;
            }
            let imgs = e;
            this.$set(this.form, "video", imgs);
            break;
        }
      }

      this.isProductUpload = false;
      this.currentHonorIndex = -1; // 重置当前操作的荣誉项索引
    },

 

    deleteImg(index, code) {
      if (code == 'album') {
        this.form.image.splice(index, 1);
      } else if (code == 'bannar') {
        this.form.bannar.splice(index, 1);
      }else if (code == 'cover') {
        this.form.cover.splice(index, 1);
      }else if (code == 'bg') {
        this.form.bg.splice(index, 1);
      }else if('qualifications' == code){
        this.form.qualifications.splice(index, 1);
      } else if (code == 'qrcode') {
    this.form.qrcode.splice(index, 1);
  }
    },

  },
  created() {
      this.getEnterpriseList();
    this.dialogVisible = this.open_add;
    if (this.open_add) {
      this.getDetail();
    }
  }
};
</script>

<style scoped>
.edit_container {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.video-upload-container {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.video-preview {
  width: 100%;
  height: 110px;
  max-height: 300px;
  background-color: #000;
  border-radius: 4px;
  margin-bottom: 10px;
}

.video-upload {
  display: inline-block;
}

.video-delete-btn {
  margin-left: 10px;
}

.el-upload__tip {
  font-size: 12px;
  color: #909399;
  margin-top: 7px;
}

.ql-editor {
  height: 400px;
}

.draggable-list {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
}

.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}
  .add-qualification, .add-honor {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 150px;
            height: 40px;
            border: 1px dashed #ddd;
            border-radius: 4px;
            cursor: pointer;
            color: #409eff;
            margin-top: 10px;
        }

        .add-qualification:hover, .add-honor:hover {
            border-color: #409eff;
        }

   .honor-input {
            flex: 1;
        }

         .qualifications-list, .honors-list {
            display: flex;
            flex-direction: column;
            gap: 15px;
            width: 100%;
        }

        .qualification-item, .honor-item {
            display: flex;
            align-items: center;
            gap: 10px;
            padding: 10px;
            border: 1px dashed #ddd;
            border-radius: 4px;
            background: #f9f9f9;
        }

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}

.qualifications-list {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.qualification-item {
  display: flex;
  align-items: center;
  gap: 10px;
}

.qualification-image {
  position: relative;
  width: 110px;
  height: 110px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.qualification-image img {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.qualification-address {
  flex: 1;
}

.add-qualification {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 110px;
  height: 40px;
  border: 1px dashed #ddd;
  border-radius: 4px;
  cursor: pointer;
  color: #409eff;
}

.add-qualification:hover {
  border-color: #409eff;
}

.delete-btn {
  cursor: pointer;
}

.max-w460 {
  max-width: 460px;
}

.pb50 {
  padding-bottom: 50px;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/supply/detail/part/edit.vue